import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import axios from "axios";

function MemberRquest() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [ratings, setRatings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    getRatings();
  }, []);

  const getRatings = async () => {
    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      const response = await axios.post(
        `${BASE_URL}/rating/get-rating-by-admin`,
        null,
        {
          params: { societyName },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRatings(response.data);
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ratings.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(ratings.length / itemsPerPage);

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div className="financial-container">

            {/* ✅ TABLE */}
            <table style={styles.table}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Employee</th>
                  <th>Company</th>
                  <th>Designation</th>
                  <th>Member</th>
                  <th>Unit No</th>
                  <th>Rating</th>
                  <th>Comment</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.employeeName}</td>
                    <td>{item.companyName}</td>
                    <td>{item.designation}</td>
                   
                    <td>{item.memberName}</td>
                      <td>{item.flatNo}</td>

                    <td>
                      {"★".repeat(item.star)}
                      {"☆".repeat(5 - item.star)}
                    </td>

                    <td>{item.comment}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* ✅ PAGINATION */}
            <div style={styles.pagination}>
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>

          </div>
        </main>
      </div>
    </div>
  );
}

export default MemberRquest;
const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    background: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
  },

  pagination: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  },
};